export const truncateToTwoDecimalPlaces = (n: number) => {
  const str = String(n);
  const [num, decimal] = str.split('.');
  if (decimal) {
    return Number([num, decimal.slice(0, 2)].join('.'));
  } else {
    return n;
  }
};
